import { useEffect, useState } from "react";
import { useFormik } from "formik";
import InfoIcon from "@mui/icons-material/Info";
import { Divider, FormControl, FormLabel, InputLabel, MenuItem, RadioGroup, TextField, Typography } from "@mui/material";
import { Button, FormControlLabel, Grid } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { Box } from "@mui/system";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { getValidationSchema, getInitialValues } from "./validation";
import { Link, useLocation } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import BpRadio from "../../bp-radio/BpRadio";
import ReviewForm from "../review-form/ReviewForm";
import { DateRange } from "@mui/icons-material";
import Breadcrumb from "../../../../UI/breadcrumb/breadcrumb";
import { groundReasonChallengeList } from "../../../../mock-data/appeal-process-data";
import FormField from "./FormField";
import { isObjectEmpty } from "../../../../helpers/filterData";
import dayjs from "dayjs";
import ApiClient from "helpers/ApiClient";
import { v4 as uuidv4 } from "uuid";
import { useAppSelector } from "store/store";
import { getToken } from "helpers/Tokens";
import { decryptRole } from "App";
import GlobalSnackBar from "UI/snackbar/GlobalSnackBar";
import "./appeal-form.scss";

const getWindowSize = () => {
  return window.innerWidth;
};
const AppealForm = () => {
  const { employee } = useAppSelector((state) => state.profile.user);
  let userData = getToken();
  let userRole = decryptRole(userData.role);
  const [NORDate, setNORDate] = useState<Date | string>("");
  const [showForm, setShowForm] = useState<boolean>(true);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [appealFormInfo, setAppealFormInfo] = useState("");
  const [pcnNumber, setNumberPcn] = useState([]);
  const [vehicleNumber, setVehicleNUmber] = useState("");
  const [locationPcn, setLocation] = useState("");
  const [offenceType, setOffenceType] = useState("");
  const [receivedNoticed, setReceivedNoticed] = useState("");
  const [pcnDate, setPcnDate] = useState("");
  const [pcnId, setPcnId] = useState<string>("");
  const [toggleSnackbar, setToggleSnackbar] = useState({
    message: "",
    isToggle: false,
    mode: "",
  });
  const [inputKey, setInputKey] = useState("");
  const [selectedPcnNumber, setSelectedPcnNumber] = useState("");
  const [selectedPcnId, setSelectedPcnId] = useState("");

  const camelize = (formType: any) =>
    formType
      .split("-")
      .map((word: string) => `${word.charAt(0).toUpperCase()}${word.slice(1)} `)
      .join("");
  const location = useLocation();
  const formType = location.pathname.slice(16);
  const appealType = camelize(formType);
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [windowSize]);
  const dateConversion = (value: any) => {
    let year = value.getFullYear();
    let month = value.getMonth() + 1;
    let date = value.getDate();
    let newDate = `${date}/${month}/${year}`;
    return newDate;
  };
  let tokenCreds = JSON.parse(localStorage.getItem("userData") || sessionStorage.getItem("userData") || "null");
  const userId = tokenCreds.id;
  const endPoint =
    userRole === "Employee"
      ? `pcn?page=1&limit=100000&vehicleId=${employee?.vehicleId}&sortBy=desc&sortField=createdAt&status=unpaid`
      : `pcn?page=1&limit=100000&userId=${userId}&sortBy=desc&sortField=createdAt&status=unpaid`;
  const getPcnNumbers = async () => {
    const res = await ApiClient.get(endPoint);
    setNumberPcn(res.data.data);
  };
  useEffect(() => {
    if (pcnNumber.length > 0) {
      const selectedRecord: any = pcnNumber.find((data: any) => data.id === values.pcnId);
      if (selectedRecord) {
        setVehicleNUmber(selectedRecord.vehicleNumber);
        setLocation(selectedRecord.location);
        setOffenceType(selectedRecord.offenceType);
        setPcnDate(dayjs(selectedRecord.issuedAt).format("YYYY/MM/DD"));
      }
    }
    if (pcnNumber.length > 0 && file) {
      const selectedRecordPcn: any = pcnNumber.find((data: any) => data.id === file);
      setSelectedPcnId(selectedRecordPcn?.id);
      if (selectedRecordPcn) {
        setSelectedPcnNumber(selectedRecordPcn.pcnNumber);
        setVehicleNUmber(selectedRecordPcn.vehicleNumber);
        setLocation(selectedRecordPcn.location);
        setOffenceType(selectedRecordPcn.offenceType);
        setPcnDate(dayjs(selectedRecordPcn.issuedAt).format("YYYY/MM/DD"));
      }
    }
  }, [pcnNumber]);
  const handleNORDate = (value: any) => {
    values.NORIssuedDate = dateConversion(value);
    setNORDate(value);
  };
  const handleAppealInfo = (payload: any) => {
    setAppealFormInfo(payload);
  };
  let fileSizeKiloBytes: any = "";
  const { values, errors, touched, handleChange, handleSubmit, setFieldValue, handleBlur } = useFormik({
    initialValues: getInitialValues(formType, vehicleNumber, pcnId, locationPcn, receivedNoticed, offenceType, pcnDate, selectedPcnNumber),
    validationSchema: getValidationSchema(formType),
    enableReinitialize: true,
    onSubmit: (values: any) => {
      fileSizeKiloBytes = values.file.size / 1024;
      if (fileSizeKiloBytes < 5120) {
        handleAppealInfo(values);
      } else {
        setToggleSnackbar({
          message: "File must be smaller then 5MB",
          isToggle: true,
          mode: "error",
        });
      }
    },
  });
  const handleShowForm = () => {
    handleSubmit();
    if (isObjectEmpty(errors) && !isObjectEmpty(touched)) {
      setShowForm(!showForm);
    }
  };
  useEffect(() => {
    getPcnNumbers();
  }, [values.pcnId, employee]);
  const handlePcnNumber = (e: any) => {
    handleChange(e);
    setPcnId(e.target.value);
  };
  const resetsFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };
  const handleReceivedNoticed = (e: any) => {
    handleChange(e);
    setReceivedNoticed(e.target.value);
    setFieldValue("file", (e.target.value = ""))
    resetsFileInput();
  };
  const { state }: any = useLocation();
  const { file }: any = state || {};

  const tempArray = [
    {
      name: "Appeals",
      onClickNavigateTo: "/appeal-process",
      color: "black",
    },
    { name: " Dashboard", onClickNavigateTo: "/", color: "#00BCD4" },
    { name: " / " },
    {
      name: "Appeal List",
      onClickNavigateTo: "/appeal-process",
      color: "#00BCD4",
    },
    {
      name: formType === "independent-adjudicator" ? ` / ${appealType}` : ` / ${appealType} Appeal`,
      onClickNavigateTo: `/appeal-process/${formType}`,
      color: "#434242",
    },
  ];
  return (
    <>
      <Box>
        <Breadcrumb breadCrumbData={tempArray} />
        {toggleSnackbar.isToggle && <GlobalSnackBar isOpenSnack={toggleSnackbar} setIsOpenSnack={setToggleSnackbar} />}
      </Box>
      {showForm ? (
        <Box className="appeal-process-form">
          <form>
            <h5 className="form-heading">{formType === "independent-adjudicator" ? `${appealType}` : `${appealType} Appeal`}</h5>
            <Divider sx={{ margin: "1rem 0" }} />
            <Grid item={true} xs={12} md={6} container spacing={2} rowSpacing={3}>
              <Grid item={true} xs={12} lg={8}>
                <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label" className={errors.receivedNoticeThrough && touched.receivedNoticeThrough ? "label-err" : "label"}>
                    Was the notice
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="receivedNoticeThrough"
                    onChange={(e: any) => handleReceivedNoticed(e)}
                    defaultValue=""
                    value={values.receivedNoticeThrough}
                  >
                    <FormControlLabel sx={{ marginRight: 0 }} value="Attached to Vehicle" control={<BpRadio />} label="Attached to Vehicle" />
                    <FormControlLabel sx={{ marginRight: 0 }} value="Recieved by post" control={<BpRadio />} label="Recieved by post" />
                    <FormControlLabel sx={{ marginRight: 0 }} value="Recieved by email or sms" control={<BpRadio />} label="Recieved by email or sms" />
                  </RadioGroup>
                </FormControl>
                {errors.receivedNoticeThrough && touched.receivedNoticeThrough && <Typography className="error-color" variant="body2"></Typography>}
              </Grid>
              {!file && (
                <FormField
                  errorMessage={errors.pcnId}
                  error={!!(errors.pcnId && touched.pcnId)}
                  label="PCN Number"
                  title="alpha-numeric field with format JHU6689CX"
                  value={values.pcnId}
                  handleChange={(e: any) => handlePcnNumber(e)}
                  name="pcnId"
                  fieldType="select"
                  handleBlur={handleBlur}
                  windowSize={windowSize}
                >
                  {pcnNumber.length>0 ? pcnNumber?.map((item: any) => (
                    <MenuItem key={uuidv4()} value={item.id}>
                      {item.pcnNumber}
                    </MenuItem>
                  )):(
                    <MenuItem>
                      No PCN Found
                    </MenuItem>
                  )}
                </FormField>
              )}
              {file && (
                <FormField
                  errorMessage={errors.pcnId}
                  error={!!(errors.pcnId && touched.pcnId)}
                  label="PCN Number"
                  title="alpha-numeric field with format JHU6689CX"
                  value={file}
                  handleChange={(e: any) => handlePcnNumber(e)}
                  name="pcnId"
                  fieldType="select"
                  handleBlur={handleBlur}
                  windowSize={windowSize}
                >
                  <MenuItem value={selectedPcnId}>{selectedPcnNumber}</MenuItem>
                </FormField>
              )}
              <Grid item={true} xs={12} lg={8}>
                <InputLabel htmlFor="PPCNDate" className={errors.pcnIssueDate && touched.pcnIssueDate ? "label-err" : "label"}>
                  PCN Date
                </InputLabel>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    value={pcnDate}
                    onChange={handleChange}
                    disabled
                    renderInput={(params) => (
                      <>
                        <TextField
                          disabled
                          name="pcnIssueDate"
                          InputProps={{
                            endAdornment: <InputAdornment position="end">{<DateRange fontSize="medium" />}</InputAdornment>,
                          }}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "#152536",
                              background: "#EBEEF1",
                              width: "100%",
                            },
                          }}
                          fullWidth
                          size="small"
                          value={pcnDate}
                          variant="outlined"
                          onBlur={handleBlur}
                          error={!!(errors.pcnIssueDate && touched.pcnIssueDate)}
                          {...params}
                        />
                      </>
                    )}
                  />
                </LocalizationProvider>
                {errors.pcnIssueDate && touched.pcnIssueDate && <Typography className="error-color" variant="body2"></Typography>}
              </Grid>
              {(formType === "formal" || formType === "independent-adjudicator") && (
                <FormField
                  errorMessage={errors.rejectionCode}
                  error={!!(errors.rejectionCode && touched.rejectionCode)}
                  label=" Rejection Code"
                  title="Numeric field 6 digits with format 000000"
                  value={values.rejectionCode}
                  handleChange={handleChange}
                  name="rejectionCode"
                  fieldType="textField"
                  handleBlur={handleBlur}
                  windowSize={windowSize}
                />
              )}
              {formType === "independent-adjudicator" && (
                <Grid item={true} xs={12} lg={8}>
                  <InputLabel htmlFor="NORIssuedDate" className={errors.NORIssuedDate && touched.NORIssuedDate ? "label-err" : "label"}>
                    NOR Issued Date
                  </InputLabel>
                  <LocalizationProvider sx={{ with: "100%" }} dateAdapter={AdapterDateFns}>
                    <DatePicker
                      value={NORDate}
                      onChange={handleNORDate}
                      renderInput={(params) => (
                        <>
                          <TextField
                            name="NORIssuedDate"
                            fullWidth
                            size="small"
                            value={dayjs(pcnDate).format("DD-MM-YYYY")}
                            variant="outlined"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={!!(errors.NORIssuedDate && touched.NORIssuedDate)}
                            {...params}
                          />
                        </>
                      )}
                    />
                  </LocalizationProvider>
                  {errors.NORIssuedDate && touched.NORIssuedDate && <Typography className="error-color" variant="body2"></Typography>}
                </Grid>
              )}
              <FormField
                errorMessage={errors.location}
                error={!!(errors.location && touched.location)}
                title="alpha-numeric field "
                label="Location"
                value={locationPcn}
                handleChange={handleChange}
                name="location"
                fieldType="textField"
                handleBlur={handleBlur}
                windowSize={windowSize}
              />
              <FormField
                errorMessage={errors.offenceType}
                error={!!(errors.offenceType && touched.offenceType)}
                title="alpha-numeric field "
                label="Offence Type"
                value={offenceType}
                handleChange={handleChange}
                name="offenceType"
                fieldType="textField"
                handleBlur={handleBlur}
                windowSize={windowSize}
              />
              <FormField
                errorMessage={errors.groundReason}
                error={!!(errors.groundReason && touched.groundReason)}
                label=" Please select the ground reason for your challenge?"
                title="single selection drop-down"
                value={values.groundReason}
                handleChange={handleChange}
                name="groundReason"
                fieldType="select"
                handleBlur={handleBlur}
                windowSize={windowSize}
              >
                {groundReasonChallengeList.map((item) => (
                  <MenuItem key={uuidv4()} value={item.challengeType}>
                    {item.challengeType}
                  </MenuItem>
                ))}
              </FormField>
              <FormField
                errorMessage={errors.challengeReason}
                error={!!(errors.challengeReason && touched.challengeReason)}
                title="text field with up to 1000 characters"
                label="Why do you want to challenge your PCN"
                value={values.challengeReason}
                handleChange={handleChange}
                name="challengeReason"
                fieldType="textArea"
                handleBlur={handleBlur}
                windowSize={windowSize}
              />
              <FormField
                errorMessage={errors.file}
                error={!!((errors.file && touched.file) || fileSizeKiloBytes > 5120)}
                title="text field with up to 1000 characters "
                label="Additional Evidence"
                fieldType="fileUpload"
                windowSize={windowSize}
              >
                <TextField
                  name="file"
                  type="file"
                  key={inputKey || ""}
                  size="small"
                  fullWidth
                  variant="outlined"
                  onChange={(e: any) => setFieldValue("file", e.target.files[0])}
                  error={!!((errors.file && touched.file) || fileSizeKiloBytes > 5120)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {(errors.file && touched.file) || fileSizeKiloBytes > 5120 ? <InfoIcon className="error" fontSize="medium" /> : <CloudUploadIcon />}
                      </InputAdornment>
                    ),
                  }}
                />
              </FormField>
              <Grid item={true} xs={12} lg={8}>
                <Box className="btn-box">
                  <Button variant="contained" className="btn-white">
                    <Link className="back-link" to={"/appeal-process"}>
                      Back
                    </Link>
                  </Button>
                  <Button onClick={handleShowForm} variant="contained" className="btn-primary">
                    Review
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      ) : (
        <ReviewForm
          file={file}
          selectedPcnId={selectedPcnId}
          appealType={appealType}
          formData={values}
          appealFormInfo={appealFormInfo}
          formType={formType}
          handleAppeal={handleSubmit}
          handleShowForm={handleShowForm}
        />
      )}
    </>
  );
};
export default AppealForm;
